import { FC } from 'react';

interface Props {
  reached: number;
  total: number;
  finished?: number;
  loading?: boolean;
}

export const FocusReachSummary: FC<Props> = ({ reached, total, finished, loading }) => {
  if (loading) return <>Checking who gets this focus…</>;
  if (total > 0 && reached === 0)
    return (
      <>
        All <strong>{total}</strong> students have already finished this unit
      </>
    );
  return (
    <>
      <strong>
        {reached} of {total}
      </strong>{' '}
      students get this focus
      {finished !== undefined && (
        <>
          {' '}
          · <strong>{finished}</strong> <span>finished</span>
        </>
      )}
    </>
  );
};
